export default __webpack_public_path__ + "static/media/030-face recognition.fd7575f3.svg";